<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text">Costos</CCardHeader>
          <CCardBody>
            <CRow class="d-flex flex-column flex-xl-row">
              <CCol md="4" lg="4" xl="4">
                <label class="d-block">Periodo:</label>
                <DateSelector class="z-custom-2" v-model="selectedDate" @input="dateSelection()" />
              </CCol>
              <CCol md="8" lg="8" xl="8">
                <CRow>
                  <CCol md="6" lg="6">
                    <label class="mt-2">Cultivo:</label>
                    <v-select
                      v-model="cultivo"
                      :options="cultivos"
                      :loading="isLoading"
                      @input="[limpiarVariedad(), filterLotes()]"
                      class="margin-multi"
                      placeholder="Selecciona un cultivo"
                    >
                      <template #open-indicator="{ attributes }">
                        <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                      </template>
                      <template #no-options>Sin resultados.</template>
                    </v-select>
                  </CCol>
                  <CCol md="6" lg="6">
                    <label class="mt-2">Variedad:</label>
                    <v-select
                      v-model="variedad"
                      :options="variedadesPorCultivo"
                      @input="filterLotes()"
                      :loading="isLoading"
                      class="margin-multi"
                      placeholder="Selecciona una variedad"
                    >
                      <template #open-indicator="{ attributes }">
                        <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                      </template>
                      <template #no-options>Sin resultados.</template>
                    </v-select>
                  </CCol>
                  <CCol md="6" lg="6">
                    <label class="mt-2">Ubicacion:</label>
                    <v-select
                      v-model="ubicacion"
                      :options="ubicaciones"
                      :loading="isLoading"
                      @input="filterLotes()"
                      class="margin-multi"
                      placeholder="Selecciona una ubicación"
                    >
                      <template #open-indicator="{ attributes }">
                        <CIcon v-bind="attributes" class="cursor-p" name="cil-caret-bottom" />
                      </template>
                      <template #no-options>Sin resultados.</template>
                    </v-select>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="this.items"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
              pagination
            >
              <template #over-table>
                <CInput v-model="filter" placeholder="Búsqueda..." />
              </template>
              <template #MOVIMIENTO_ID="{item}">
                <td class="py-2">{{ item.MOVIMIENTO_ID }}</td>
              </template>
              <template #FECHAHORA="{item}">
                <td class="py-2">{{ getDate(item.FECHAHORA) }}</td>
              </template>
              <template #UBICACION_NOMBRE="{item}">
                <td class="py-2">{{ item.ATRIBUTOS.UBICACION_NOMBRE }}</td>
              </template>
              <template #CULTIVO_NOMBRE="{item}">
                <td class="py-2">{{ item.ATRIBUTOS.CULTIVO_NOMBRE }}</td>
              </template>
              <template #CULTIVO_VARIEDAD="{item}">
                <td class="py-2">{{ item.ATRIBUTOS.CULTIVO_VARIEDAD }}</td>
              </template>
              <template #CONCEPTO_TIPO="{item}">
                <td class="py-2">{{ item.ATRIBUTOS.CONCEPTO_TIPO }}</td>
              </template>
              <template #CONCEPTO_NOMBRE="{item}">
                <td class="py-2">{{ item.ATRIBUTOS.CONCEPTO_NOMBRE }}</td>
              </template>
              <template #UNIDAD="{item}">
                <td class="py-2">{{ item.ATRIBUTOS.UNIDAD }}</td>
              </template>
              <template #CANTIDAD="{item}">
                <td class="py-2">{{ item.ATRIBUTOS.CANTIDAD }}</td>
              </template>
              <template #MONTO="{item}">
                <td class="py-2">${{ item.MONTO }}</td>
              </template>
              <!-- <template #under-table>
                <CPagination
                  :activePage.sync="page"
                  :pages="pages"
                  align="center"
                  @update:activePage="e => changePage(e)"
                />
              </template>-->
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import moment from "moment";
import DateSelector from "../../customComponents/DateSelector";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const today = new Date();

const fields = [
  { key: "MOVIMIENTO_ID", label: "Folio", _style: "width:10%" },
  { key: "FECHAHORA", label: "Fecha", _style: "width:10%" },
  { key: "UBICACION_NOMBRE", label: "Ubicación", _style: "width:10%" },
  { key: "CULTIVO_NOMBRE", label: "Cultivo", _style: "width:10%" },
  { key: "CULTIVO_VARIEDAD", label: "Variedad", _style: "width:10%" },
  { key: "CONCEPTO_TIPO", label: "Concepto", _style: "width:10%" },
  // { key: "CONCEPTO_NOMBRE", label: "Categoría", _style: "width:10%" },
  // { key: "CONCEPTO_NOMBRE", label: "Nombre", _style: "width:10%" },
  { key: "UNIDAD", label: "Unidad", _style: "width:10%" },
  { key: "CANTIDAD", label: "Cantidad", _style: "width:10%" },
  // { key: "costoUnitario", label: "Costo Unitario", _style: "width:10%" },
  { key: "MONTO", label: "Costo total", _style: "width:10%" }
  // { key: "costoTotal", label: "Costo total",_style: "width:10%" }
];

export default {
  name: "Costos",
  components: {
    DateSelector,
    vSelect
  },

  data() {
    return {
      options: ["hola", "adios"],
      isCreated: false,
      items: [],
      fields,
      ubicaciones: [],
      cultivos: [],
      variedades: [],
      lotes: [],
      itemsFiltro: [],
      cultivo: null,
      variedad: null,
      ubicacion: null,
      lote: null,
      filter: "",
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      loteLabel: "",
      isLoteActive: false,
      isLoading: false,
      color1: "primary",
      color2: "secondary",
      selectedDate: {
        start: new Date(today.getFullYear(), today.getMonth(), 1),
        // start: new Date(2019, 1, 1),
        end: new Date(today.getFullYear(), today.getMonth() + 1, 0)
        // end: new Date(2020, 2, 11)
      }
    };
  },

  created() {
    this.actualizarInfo()
  },

  computed: {
    rangeStart() {
      return new Date(this.selectedDate.start).toLocaleDateString();
    },
    rangeEnd() {
      return new Date(this.selectedDate.end).toLocaleDateString();
    },
    clave_empresa() {
      return this.$store.state.clave_empresa.toUpperCase();
    },
    variedadesPorCultivo() {
      const cultivo = this.cultivo
      return cultivo === null ? [] : this.variedades.filter(variedad => {
        return cultivo.label === variedad.cultivo
      });
    }
  },

  methods: {
    changePage(e) {
      console.log(e);
    },
    toggleLote() {
      this.isLoteActive = !this.isLoteActive;
      this.color1 = this.isLoteActive ? "primary" : "secondary";
      this.color2 = this.isLoteActive ? "secondary" : "primary";
      this.isLoteActive
        ? ((this.cultivo = null), (this.ubicacion = null))
        : (this.lote = null);
      this.filterLotes();
    },
    dateSelection() {
      if (this.isCreated) {
        this.actualizarInfo();
      }
    },
    filterLotes() {
      if (this.isCreated) {
        this.actualizarInfo();
      }
      // let compareLote = this.lotes.find(
      //   lote => lote.value == (this.lote ? this.lote.value : null)
      // );

      // return this.isLoteActive
      //   ? this.items
      //       .filter(
      //         mov =>
      //           mov.ATRIBUTOS.LOTE ==
      //           (compareLote ? compareLote.label : mov.ATRIBUTOS.LOTE)
      //       )
      //       .filter(
      //         mov =>
      //           new Date(mov.FECHAHORA) >= this.selectedDate.start &&
      //           new Date(mov.FECHAHORA) <= this.selectedDate.end
      //       )
      //   : this.items
      //       .filter(
      //         mov =>
      //           mov.ATRIBUTOS.CULTIVO_ID ==
      //           (this.cultivo ? this.cultivo.value : mov.ATRIBUTOS.CULTIVO_ID)
      //       )
      //       .filter(
      //         mov =>
      //           mov.CRITERIOS.UBICACION_ID ==
      //           (this.ubicacion
      //             ? this.ubicacion.value
      //             : mov.CRITERIOS.UBICACION_ID)
      //       )
      //       .filter(
      //         mov =>
      //           new Date(mov.FECHAHORA) >= this.selectedDate.start &&
      //           new Date(mov.FECHAHORA) <= this.selectedDate.end
      //       );
    },
    limpiarVariedad() {
      this.variedad = null
    },
    toggleMonth() {
      this.selectedDate.start = new Date(
        today.getFullYear(),
        today.getMonth(),
        1
      );
      this.selectedDate.end = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        0
      );
    },
    toggleLastMonth() {
      this.selectedDate.start = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1
      );
      this.selectedDate.end = new Date(
        today.getFullYear(),
        today.getMonth(),
        0
      );
    },
    toggleYear() {
      this.selectedDate.start = new Date(today.getFullYear(), 0, 1);
      this.selectedDate.end = new Date(today.getFullYear(), 11, 31);
    },
    getDate(date) {

      return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY');
    },
    actualizarInfo() {
      this.isLoading = true;

      if (!this.isCreated) {
        const catalogos = [
          this.$store.dispatch('customHTTP', {
            schema: 'configuracion',
            filter: {
              where: [{field: 'payload->parametro', value: 'cultivos', operator: '='}]
            }
          }),
          this.$store.dispatch("customHTTP", {
            schema: "ubicaciones",
            filter: {
              where: [
                {
                  field: "payload->suspendido",
                  value: false,
                  operator: "="
                }
              ]
            },
            order:[{
              field: 'payload->nombre',
              direction: 'asc'
            }]
          }),
          this.$store.dispatch("customHTTP", { schema: "cultivos" }),
          this.$store.dispatch("customHTTP", { schema: "lotes" })
        ];
        Promise.all(catalogos)
          .then(([configuracion, ubicaciones, cultivos, lotes]) => {
            this.cultivos = configuracion.data[0].payload.valor.map((cultivo) => {
              return {label: cultivo.nombre}
            })
            this.variedades = cultivos.data.map(cultivo => {
              return { value: cultivo.id, label: cultivo.payload.variedad, cultivo: cultivo.payload.nombre};
            }).filter(variedad => {
              return variedad.label != undefined
            });
            this.ubicaciones = ubicaciones.data.map(ubicacion => {
              return { value: ubicacion.id, label: ubicacion.payload.nombre };
            });
            this.lotes = lotes.data.map(lote => {
              return { value: lote.id, label: lote.payload.nombre };
            });
          })
        this.isCreated = true;
      }


      let template = {
        RUTA_MODULO: `${this.clave_empresa}:C4.BALANCE_FINANCIERO.COSTO`,
        FECHA:
        {
          WHERE:
          {
            OPERATOR: 'BETWEEN',
            VALUE: [
              moment(this.selectedDate.start).format("YYYY-MM-DD"),
              moment(this.selectedDate.end).format("YYYY-MM-DD")
            ]
          }
        },
        OPTIONS: {
            LIMIT: {
                PAGE: 0,
                SIZE: 50
            }
        },
        ATRIBUTOS: {
          // CULTIVO_ID: "1",  //Esta es la variante
          // CULTIVO_NOMBRE: "Arándano",
          // UBICACION_ID: "1"
        }
      }

      this.cultivo != null ? (template = {
        ...template,
        ATRIBUTOS: {
          ...template.ATRIBUTOS,
          CULTIVO_NOMBRE: this.cultivo.label
        }
      }) : null

      this.variedad != null ? (template = {
        ...template,
        ATRIBUTOS: {
          ...template.ATRIBUTOS,
          CULTIVO_VARIEDAD: this.variedad.label
        }
      }) : null

      this.ubicacion != null ? (template = {
        ...template,
        ATRIBUTOS: {
          ...template.ATRIBUTOS,
          UBICACION_ID: this.ubicacion.value
        }
      }) : null

      // console.log(template)

      this.$store.dispatch("customBalanceHTTP", {
        tipo_balance: "financiero",
        tabla: "movimientos",
        movimientos: [template]
      }).then((balances) => {
        this.items = balances.data[0].RESOURCE;
        this.itemsFiltro = balances.data[0].RESOURCE;
      }).finally(() => (this.isLoading = false))

      // this.isLoading = false

    }
  }
};
</script>

<style scoped>
.z-custom {
  z-index: 1;
}
.z-custom-2 {
  z-index: 4;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
